var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-end"},[_c('div',[_vm._v(" Masz pytania? Napisz do nas:"),_c('br'),_c('a',{attrs:{"href":"mailto:pomoc@klubpirelli.pl"}},[_vm._v("pomoc@klubpirelli.pl")])])])
}]

export { render, staticRenderFns }